import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=14497e83&"
import script from "./temp.vue?vue&type=script&lang=js&"
export * from "./temp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14497e83')) {
      api.createRecord('14497e83', component.options)
    } else {
      api.reload('14497e83', component.options)
    }
    module.hot.accept("./temp.vue?vue&type=template&id=14497e83&", function () {
      api.rerender('14497e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/temp.vue"
export default component.exports